import * as modules from '@modules';
import { Reducer } from '@reduxjs/toolkit';
import { Reducers } from './store.types';

const { base, ...customModules } = modules;

function hasSlice(module: any): module is { slice: { name: string; reducer: any } } {
  return module && module.slice && typeof module.slice.name === 'string' && typeof module.slice.reducer !== 'undefined';
}

export default Object.values(customModules).reduce(
  (reducers, module) =>
    hasSlice(module)
      ? {
          ...reducers,
          [module.slice.name]: module.slice.reducer,
        }
      : reducers,
  {} as Reducers,
);
